
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 11v10h24V11","stroke":"#1565C0","stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M13.5 1v14","stroke":"#1565C0","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 11.5l3.5 3.5 3.5-3.5","stroke":"#1565C0","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    